import { Injectable } from '@angular/core';
import {
  EventCategories,
  GoogleAnalyticsService,
} from '../../google/services/google-analytics.service';
import { BathSpCalculatorDialogComponent } from '../dialogs/bath-sp-calculator-dialog/bath-sp-calculator-dialog.component';
import { IReturnData } from '../dialogs/bath-sp-calculator-dialog/models/i-return-data.interface';
import { SideDialogService } from '../side-dialog/side-dialog.service';

@Injectable({
  providedIn: 'root',
})
export class BathSpCalculator {
  constructor(
    private sideDialogService: SideDialogService,
    private gaServices: GoogleAnalyticsService
  ) {}

  show(): Promise<any> {
    return new Promise<any>((resolve) => {
      this.gaServices.trackEvent_Old(
        EventCategories.staticPressureCalculator,
        'Open'
      );

      const dialogRef = this.sideDialogService.open<IReturnData>(
        BathSpCalculatorDialogComponent,
        {
          disableClose: false,
          autoFocus: true,
          width: 1000,
        }
      );

      const subscription = dialogRef.closed.subscribe((results) => {
        subscription.unsubscribe();

        resolve(results);
      });
    });
  }
}
